import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { services } from '../data/services';
export function ServicesSection() {
  return <section id="services" className="w-full bg-white py-16 sm:py-20" data-id="element-285" data-mp="2gabpywpshtl8">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-286" data-mp="2gcfv1hzfcyn3">
        <div className="max-w-2xl" data-id="element-287" data-mp="2l8mzt7g3443g">
          <h2 className="font-display text-3xl font-800 text-ink" data-id="element-288" data-mp="2l7lgygstudb6">Rentals for every trip</h2>
          <p className="mt-3 text-ink-soft" data-id="element-289" data-mp="26j8se4w2jwqp">
            Three simple ways to ride with drivesewa.com — each with clear day and night pricing.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-290" data-mp="1xkwtlfl1tsn6">
          {services.map((s, i) => {
          const Icon = s.icon;
          return <motion.div key={s.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.08
          }} className="group rounded-2xl border border-slate-200 bg-white p-6 transition-shadow hover:shadow-lg hover:shadow-slate-900/5" data-id="element-291" data-mp="22gkgtpfz0bq1" data-mpi={i}>
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand-600" data-id="element-292" data-mp="2yo961yc5p98u">
                  <Icon className="h-6 w-6" data-id="element-293" data-mp="2unff0w3f3ebq" />
                </span>
                <h3 className="mt-4 font-display text-lg font-700 text-ink" data-id="element-294" data-mp="26wjsoehqdbbv">{s.label}</h3>
                <p className="mt-2 text-sm text-ink-soft" data-id="element-295" data-mp="21xoykgebc0cg">{s.description}</p>
                <a href="#book" className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-600" data-id="element-296" data-mp="21vm3vj27tj1e">
                  Book this
                  <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-297" data-mp="2awajujb65tgx" />
                </a>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}